import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const CalendarIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 2v2.222h9V2h2.25v2.222h1.125c.621 0 1.125.498 1.125 1.111V20.89c0 .614-.504 1.111-1.125 1.111H4.125A1.12 1.12 0 0 1 3 20.889V5.333c0-.613.504-1.11 1.125-1.11H5.25V2zM5.25 19.778V8.667h13.5v11.11z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
